export const categories = [
  {
    slug: 'controversial',
    name: '争议言论',
    desc: '一句脱口而出的话，如何在两种语境里被解读成完全不同的意思。',
    icon: 'ri-megaphone-line',
    accent: 'primary',
  },
  {
    slug: 'flame-war',
    name: '网络骂战',
    desc: '评论区里的情绪风暴，看不同平台的讨论规则如何塑造骂战形态。',
    icon: 'ri-fire-line',
    accent: 'primary',
  },
  {
    slug: 'value-clash',
    name: '价值观碰撞',
    desc: '集体与个人、含蓄与直白，两套底层逻辑正面相遇时的火花。',
    icon: 'ri-scales-3-line',
    accent: 'accent',
  },
  {
    slug: 'political-correctness',
    name: '政治正确',
    desc: '公共表达的边界在哪里，不同社会给出了各自的答案。',
    icon: 'ri-shield-check-line',
    accent: 'secondary',
  },
  {
    slug: 'car-crash',
    name: '翻车现场',
    desc: '公关话术、镜头失误与语境错位，那些被放大到全网的名场面。',
    icon: 'ri-alarm-warning-line',
    accent: 'accent',
  },
];